import React from 'react';
import { TeamOutlined, MobileOutlined } from '@ant-design/icons';
import {
  MdAccountBalance, MdInsertEmoticon, MdDataUsage, MdPersonOutline,
} from 'react-icons/md';
import {
  ACTIVITIES,
  DASHBOARD_HOME,
  LEARNING,
  MESSAGING_EMAIL,
  MESSAGING_SMS,
  PROFILE,
  SETUP_COHORT,
  SETUP_USERS,
  STUDENT_ACTIVITIES,
  STUDENT_HOME,
  STUDENT_PROFILE,
  STUDENT_SUPPORT,
  SUPPORT,
} from './paths';

/**
 * Sidebar navigation only. These used to carry the component to render as
 * well, which meant the menu and the route table were the same list — adding
 * a screen without a menu entry meant adding a hidden entry. Routing now
 * lives in AppRoutes; this is just what appears in the sidebar.
 */
const iconStyles = { marginLeft: '30px', marginRight: '10px' };

const dashboardItem = {
  title: 'Dashboard',
  hasSubRoute: false,
  icon: <i data-icon="/" className="icon" />,
  path: DASHBOARD_HOME,
  key: '1',
};

const learningItem = {
  title: 'Learning',
  hasSubRoute: false,
  icon: <i className="icon icon-graduation" />,
  path: LEARNING,
  key: '2',
};

const activitiesItem = {
  title: 'Activities',
  hasSubRoute: false,
  icon: <i className="icon icon-megaphone" />,
  path: ACTIVITIES,
  key: '3',
};

const supportItem = {
  title: 'Support',
  hasSubRoute: false,
  icon: <i data-icon="-" className="icon" />,
  path: SUPPORT,
  key: '4',
};

const profileItem = {
  title: 'Profile',
  hasSubRoute: false,
  icon: <i className="icon icon-user-o" />,
  path: PROFILE,
  key: '6',
};

export const instructorAdmin = [
  dashboardItem,
  learningItem,
  activitiesItem,
  supportItem,
  {
    title: 'Message',
    hasSubRoute: true,
    icon: <i data-icon="~" className="icon" />,
    key: '5',
    path: 'messaging',
    sub: [
      {
        path: MESSAGING_SMS, title: 'SMS', icon: <i className="icon icon-chat-bubble" />,
      },
      {
        path: MESSAGING_EMAIL, title: 'Email', icon: <MobileOutlined style={iconStyles} />,
      },
    ],
  },
  profileItem,
  {
    title: 'Setup',
    hasSubRoute: true,
    icon: <i className="icon icon-components" />,
    key: '7',
    path: 'setup',
    sub: [
      {
        path: SETUP_USERS, title: 'Users', icon: <TeamOutlined style={iconStyles} />,
      },
      {
        path: SETUP_COHORT, title: 'Cohort', icon: <i className="icon icon-growth" />,
      },
    ],
  },
];

export const instructor = [
  dashboardItem,
  learningItem,
  activitiesItem,
  supportItem,
  profileItem,
];

export const student = [
  {
    title: 'Home', icon: <MdAccountBalance />, path: STUDENT_HOME, key: '1',
  },
  {
    title: 'Activities', icon: <MdInsertEmoticon />, path: STUDENT_ACTIVITIES, key: '2',
  },
  {
    title: 'Support', icon: <MdDataUsage />, path: STUDENT_SUPPORT, key: '3',
  },
  {
    title: 'My Profile', icon: <MdPersonOutline />, path: STUDENT_PROFILE, key: '4',
  },
];
